var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ac-inline-form-edit',{attrs:{"form_json":_vm.formData},on:{"updated_value":_vm.updatedValue}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }